define('modules/layout',["jquery", "app", "snap"], function($, App, Snap) {
    // Used for determining font-size of rack name
    $('body').append('<span id="tester" style="position:fixed;top:-1000px;left:0"></span>');

    //Get screen dimensions, ignore 20px for scrollbars
    function getScreenDimensions() {
        return {
            width : window.innerWidth - 20,
            height : window.innerHeight - 20
        };
    }

    //Point Class Definition
    function Point(x,y) {
        this.x = x;
        this.y = y;
    }

    Point.prototype.distanceTo = function(p) {
        return Math.sqrt((p.x-this.x)*(p.x-this.x)+(p.y-this.y)*(p.y-this.y));
    };

    //Lay layout
    function lay(id, layout) {
        var utilityList = {};
        var rackList = {};

        //Get dimensions of floor
        var dimensions = fixDimensions(layout.dimensions, {
            width : 0,
            height : 130
        });
        var nw = dimensions.width;
        var nh = dimensions.height;

        //Horizontal and vertical Multipliers to scale original co-ordinates to screen size
        var hm = layout.unit.x * dimensions.multipliers.x;
        var vm = layout.unit.y * dimensions.multipliers.y;

        !layout.gridUnit && (layout.gridUnit = $.extend({}, layout.unit));
        var ghm = layout.gridUnit.x * dimensions.multipliers.x;
        var gvm = layout.gridUnit.y * dimensions.multipliers.y;

        //Create and append a new svg for the layout
        var svg = $('<svg id="' + id + '"></svg>');

        //Append the svg to dom to be able to access it from Snap
        $('#hiddenContent').append(svg);

        //Initiate snap
        var s = Snap('#' + id);

        //Lay racks
        $.each(layout.racks ,function(j,rack) {
            //Genrate front points to connect the path to
            var frontPoints = [];
            if(rack.fp) {
                frontPoints = rack.fp.map(function(p){
                    var t = p.split(',').map(Number);
                    t[0] *= layout.unit.x / layout.gridUnit.x;
                    t[1] *= layout.unit.y / layout.gridUnit.y;
                    return t;
                });

                //Store all ids in a list(used to check whether location for a rack exists or not)
                if(frontPoints.length) {
                    if(rack.type=='uniquerack') {
                        rackList[rack.id] = frontPoints;
                    } else if(rack.type=='utility') {
                        checkKeyAndPush(utilityList, rack.name.toLowerCase(), frontPoints);
                    } else if(rack.type == 'floorchange') {
                        rack.goes.forEach(function(g) {
                            checkKeyAndPush(utilityList, 'go ' + g, frontPoints);
                        });
                    }
                }
            }

            var points = {
                pointstring : ''
            };

            //Create co-ordinate array from co-ordinate string and convert them to integers
            var coords = rack.coords.trim().split(' ').map(function(c){
                return c.split(',').map(Number);
            });

            //Create points and point string(used for path)
            coords = coords.map(function(coord, i) {
                coord = [coord[0]*hm, coord[1]*vm];

                var pc = 'p'+ (i + 1);
                points[pc] = new Point(coord[0], coord[1]);

                if(i>=1) {
                    points.pointstring += (i==1 ? '' : ' ') + points[pc].x + ',' + points[pc].y;
                }

                return coord;
            });

            //Draw rack
            (function() {
                //Generate path
                var attributes = {
                    'title' : rack.name,
                    'class':'rack',
                };

                if(rack.stroke) {
                    //Calculate pixel dasharray from unit dasharray
                    attributes['stroke-dasharray'] = (function() {
                        var index = 0;
                        var nextIndex;
                        var strokeArray = [];
                        var isZero = false;
                        rack.stroke.split(',').forEach(function(stroke, i) {
                            stroke = +stroke;
                            if(stroke) {
                                index++;
                                nextIndex = index + 1;
                                if(nextIndex > coords.length) {
                                    nextIndex = 1;
                                }

                                var strokeSize = stroke * points['p' + index].distanceTo(points['p' + nextIndex]);
                                if(isZero && strokeArray.length) {
                                    strokeArray.push(strokeArray.pop() + strokeSize);
                                } else {
                                    strokeArray.push(strokeSize);
                                }
                            } else if(i==0) {
                                strokeArray.push(stroke);
                                stroke = 1;
                            }
                            isZero = !stroke;
                        });
                        return strokeArray.toString();
                    })();
                }

                if(rack.id) {
                    attributes.id = 'rack-'+rack.id;
                }

                if(!frontPoints.length) {
                    attributes.class += ' wall';
                }

                //Draw rack
                s.path(Snap.format("M{p1.x},{p1.y} L{pointstring}Z", points)).attr(attributes);

                //Draw rack name
                if(rack.name && rack.name!='NA' && frontPoints.length) {
                    var text = s.text(0, 0, rack.name);
                    text.attr(getTextPath(coords, rack.name));
                    text.textPath.attr({
                        startOffset : '50%'
                    });
                }
            })();
        });

        //Save the generated svg DOM object in memory and remove it from DOM
        svg = $('#' + id).clone(true);
        $('#' + id).remove();

        return {
            dimensions : {
                width : nw,
                height : nh
            },
            unit : {
                x : ghm,
                y : gvm
            },
            svg : $('<div/>').append(svg).html(),
            racks : rackList,
            utilities : utilityList,
        };
    }

    //Check key and push
    function checkKeyAndPush(object, key, value) {
        if(!object[key]) {
            object[key] = [];
        }
        object[key].push(value);
    }

    //Check if given points form a non angular rectangle
    function isRectangle(p1, p2, p3, p4) {
        return (p1.x == p2.x || p1.y == p2.y)&&(p2.x == p3.x || p2.y == p3.y)&&(p3.x == p4.x || p3.y == p4.y)&&(p4.x == p1.x || p4.y == p1.y);
    }

    //Calculate textpath and font-size
    function textParams (points, name) {
        // Declare required variables
        // box coords : ss,se,es,ee (used to calculate ps and pe)
        // path coords : ps = path start , pe = path end (used for textpath)
        // se............ee            ee............es
        //  .            .              .     pe     .
        //  .            .              .      .     .
        //  .            .              .      e     .
        //  .            .              .      m     .
        //  ..ps.name.pe..    (or)      .      a     .
        //  .            .              .      n     .
        //  .            .              .      .     .
        //  .            .              .     ps     .
        // ss............es            se............ss

        var rectangle = isRectangle(points.p1, points.p2, points.p3, points.p4);

        //Polygon vertices. s : start, e : end
        var ss, se, es, ee;

        // x : [x co-ordinates] , y : [y co-ordinates]
        var x = [], y = [];

        //Width and height of rack
        var rw, rh;

        //Calculate box coords for a non angular rectangle
        if(rectangle) {
            //Get min and max x values
            push(x,$.map(points, function(p) { return p.x; }));
            x.sort(function(a,b){return a-b;});


            //Get min and max y values
            push(y,$.map(points, function(p) { return p.y; }));
            y.sort(function(a,b){return a-b;});

            //Form box from min and max x and y values
            ss = new Point(x[0],y[1]);
            se = new Point(x[0],y[0]);
            es = new Point(x[1],y[1]);
            ee = new Point(x[1],y[0]);

            //Calculate width and height of rack
            rw = ss.distanceTo(es);
            rh = ss.distanceTo(se);
        }
        //Calculate box coords for a 4 sided polygon
        else {
            //Convert points object to array for sorting
            var pointArray = Object.keys(points);
            pointArray = pointArray.map(function(key){ return points[key]; });

            //Sort points array based on y values
            pointArray.sort(function(a,b){ return a.y-b.y; });

            //Get first 2 values of sorted points array and sort them by x to get left and right points of top border of polygon
            var sPoints = pointArray.slice(0, 2).sort(function(a,b){ return a.x-b.x; });

            //Do likewise for last 2 values to get points for bottom border of polygon
            var ePoints = pointArray.slice(2).sort(function(a,b){ return a.x-b.x; });

            //Form box from above values
            ss = ePoints[0];
            se = sPoints[0];
            es = ePoints[1];
            ee = sPoints[1];

            //Calculate min width and min height of the sides
            rw = Math.min.apply(Math,[ss.distanceTo(es), se.distanceTo(ee)]);
            rh = Math.min.apply(Math,[ss.distanceTo(se), es.distanceTo(ee)]);
        }

        //Temporary variable for multiple usecases
        var t;

        //If width is less than height change the orientation of text for better visibility
        if(rw < rh) {
            //rotate points anticlock wise
            t = ss;
            ss = es;
            es = ee;
            ee = se;
            se = t;

            //Switch rw and rh
            t = rw;
            rw = rh;
            rh = t;
        }

        //Effective width and height for text with padding of 10% on each direction
        var trw = rw*0.8;
        var trh = rh*0.8;

        //Initial font-size before starting adjusting
        var fs = trw/name.length;

        //Psuedo invisible element to calculate width and height of text element with given font-size
        $('#tester').html(name).css({
            'font-size' : fs+'px'
        });

        //Keep reducing font-size until width and height of text element fits in the box after padding
        while(($('#tester').width()>trw||$('#tester').height()>trh)&&(fs-0.25>0)) {
            fs = fs-0.25;
            $('#tester').css({
                'font-size':fs+'px'
            });
        }

        //Get width and height of text at current font size
        var tw = $('#tester').width();
        var th = $('#tester').height();

        //Calculate gap to leave. ew : horizontal gap , eh : vertical gap
        //1 for first side, 2 for second side according to orientation
        var eh1, eh2;
        if(rectangle) {
            eh1 = eh2 = (1 - th/rh)/2;
        }
        else {
            eh1 = (1 - th/ss.distanceTo(se))/2;
            eh2 = (1 - th/es.distanceTo(ee))/2;
        }

        //Calculate points on sides at fraction of eh from bottom
        var ps = new Point(ss.x+eh1*(se.x-ss.x),ss.y+eh1*(se.y-ss.y));
        var pe = new Point(es.x+eh2*(ee.x-es.x),es.y+eh2*(ee.y-es.y));

        ps.x -= 1;
        pe.x -= 1;
        ps.y -= 1;
        pe.y -= 1;
        //textpath from ps and pe, calculated font-size
        return {
            textpath: "M"+ps.x+","+ps.y+" L"+pe.x+","+pe.y,
            class: 'rackname',
            'font-size':fs+'px',
            'text-anchor': 'middle',
            'dominant-baseline': 'ideographic',
        };
    }

    //Utility custom array push to push only unique values
    function push(array, value) {
        if($.isArray(value)) {
            $.each(value,function(i,val){
                push(array,val);
            });
        } else if($.inArray(value,array) == -1) {
            array.push(value);
        }
    }

    function fixDimensions(dimensions, adjustments) {
        adjustments = adjustments || {width : 0, height : 0};

        var screenDimensions = getScreenDimensions();
        var screenWidth = screenDimensions.width - adjustments.width;
        var screenHeight = screenDimensions.height - adjustments.height;
        var fw = dimensions.length;
        var fh = dimensions.width;

        //Calculate the height of layout ,by placing length on width of screen
        var nw = screenWidth;
        var nh = (fh/fw)*nw;

        //If height is going out of screen, adjust width so that height fits in screen
        if(nh>screenHeight)  {
            nw *= (screenHeight/nh);
            nh = screenHeight;
        }

        return {
            width : nw,
            height : nh,
            multipliers : {
                x : nw/dimensions.length,
                y : nh/dimensions.width
            }
        };
    }

    function getTextPath(points, name) {
        var pointObject = {};

        if(points.length >= 4) {
            //If polygon had more than 4 sides consider only first 4 sides
            points = points.slice(0,4);
        } else {
            //If triangle make a quadrilateral inside the triangle, consider large side for better visibility of text
            var largeSideVertices = [];
            var largeSide = 0;
            var currentIndex, nextIndex;
            var nextPoint, prevPoint, firstPoint;
            for(var i = 0; i < 3; i ++) {
                currentIndex = i;
                if(!prevPoint) {
                    prevPoint = firstPoint = new Point(points[i][0],points[i][1]);
                }
                if(!points[i+1]) {
                    nextPoint = firstPoint;
                    nextIndex = 0;
                } else {
                    nextIndex = i+1;
                    nextPoint = new Point(points[nextIndex][0],points[nextIndex][1]);
                }

                //Calculate distance and check if it larger than existing large side
                var distance = nextPoint.distanceTo(prevPoint);
                if(distance > largeSide) {
                    largeSide = distance;
                    largeSideVertices = [currentIndex, nextIndex];
                }
                prevPoint = nextPoint;
            }

            var p1 = points[largeSideVertices[0]];
            var p2 = points[largeSideVertices[1]];
            var p3 = points[largeSideVertices[1] == 2 ? 0 : largeSideVertices[1]+1];
            var m = 3/5;
            points = [];
            points.push(p1);
            points.push(p2);

            //Get points on the not larger sides of triangle at a ratio of 2/5 from the opposite vertex
            points.push([p2[0] + m*(p3[0]-p2[0]) , p2[1] + m*(p3[1]-p2[1])]);
            points.push([p1[0] + m*(p3[0]-p1[0]) , p1[1] + m*(p3[1]-p1[1])]);
        }

        points.forEach(function(p, i) {
            pointObject['p' + (i+1)] = new Point(p[0],p[1]);
        });

        return textParams(pointObject, name);
    }

    return {
        lay : lay,
        fixDimensions : fixDimensions,
        getTextPath : getTextPath
    };
});
